import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./VisioQuest.css";

import VisioQuestImg from "../../works_images/works3.png";
import VisioQuestImg1 from "../../works_images/works3.1.png";
import VisioQuestImg2 from "../../works_images/works3.2.png";
import VisioQuestImg3 from "../../works_images/works3.3.png";
import VisioQuestImg4 from "../../works_images/works3.4.png";

const ArrowLeft = ({ className, style, onClick }) => (
  <div
    className={`${className} custom-arrow left`}
    style={{ ...style }}
    onClick={onClick}
  >
    <FaChevronLeft />
  </div>
);

const ArrowRight = ({ className, style, onClick }) => (
  <div
    className={`${className} custom-arrow right`}
    style={{ ...style }}
    onClick={onClick}
  >
    <FaChevronRight />
  </div>
);

const VisioQuest = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");

  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
  };

  const images = [
    { src: VisioQuestImg, alt: "VisioQuest screenshot 1" },
    { src: VisioQuestImg1, alt: "VisioQuest screenshot 2" },
    { src: VisioQuestImg2, alt: "VisioQuest screenshot 3" },
    { src: VisioQuestImg3, alt: "VisioQuest screenshot 4" },
    { src: VisioQuestImg4, alt: "VisioQuest screenshot 5" },
  ];

  return (
    <div className="project-page-container VisioQuest-project">
      <div className="project-page-content">
        <button
          type="button"
          onClick={handleBack}
          className="back-button"
          aria-label="Back to Home"
        >
          &larr; Back to Home
        </button>

        <div className="project-header">
          <h1>VisioQuest:</h1>
          <h2> AI Face Recognition App</h2>
          <p className="project-subtitle">
            A case study in full-stack development and third-party API
            integration.
          </p>
        </div>

        <div className="project-main-content">
          <div className="project-left-column">
            <h2>About The Project</h2>
            <p>
              VisioQuest is a web application that demonstrates the practical
              application of artificial intelligence for image analysis. Users
              can paste a URL for any online image, upload a photo from their
              device via file picker or drag-and-drop, or select from built-in
              sample images and instantly see the human faces detected and
              highlighted with bounding boxes.
            </p>

            <h2>Technical Deep Dive</h2>
            <p>
              The application is built on a hybrid client-server architecture
              designed for speed and zero-cost operation. The frontend,
              developed with React, runs MediaPipe Face Detection entirely in
              the browser using WebAssembly. Face detection happens client-side
              with no API keys, no usage limits, and no cold-start delays.
              Google's open-source MediaPipe model loads once and processes
              images locally, keeping the experience fast and free.
            </p>
            <p>
              The Node.js backend serves as a CORS image proxy. When the browser
              can't access an image's pixel data due to cross-origin
              restrictions, the backend fetches the image and returns it as a
              base64 data URL that MediaPipe can process. This hybrid approach,
              client-side AI with a server fallback for edge cases, eliminates
              the latency and cost of routing every request through a backend
              while still handling real-world browser security constraints. The
              backend is deployed on Render and the frontend on Netlify.
            </p>
          </div>
          <div className="project-right-column">
            <div className="project-image-container">
              <Slider {...settings}>
                {images.map((img, idx) => (
                  <div key={idx}>
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="project-image"
                    />
                  </div>
                ))}
              </Slider>
              <div className="project-buttons">
                <a
                  href="https://face-recognition-visioquest.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button"
                >
                  Website
                </a>
                <a
                  href="https://github.com/Taniatos/face-recognition-app-visioquest"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button secondary"
                >
                  Code
                </a>
              </div>
            </div>
            <div className="project-technology-container">
              <h2>Technology used</h2>
              <ul>
                <li>
                  <strong>Frontend:</strong> React 18, JavaScript (ES6+), CSS3
                </li>
                <li>
                  <strong>Backend:</strong> Node.js, Express.js
                </li>
                <li>
                  <strong>AI/ML:</strong> MediaPipe Face Detection
                  (@mediapipe/tasks-vision), client-side via WebAssembly
                </li>
                <li>
                  <strong>Security:</strong> CORS image proxy on backend,
                  environment variables for configuration
                </li>
                <li>
                  <strong>Deployment:</strong> Full-stack deployment using
                  Netlify (frontend) and Render (backend)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisioQuest;
